export default "__VITE_ASSET__D6s8GUvf__"